import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

import { TruncatePipeModule } from '@shared/core/pipes/truncate';

import { OrderIdModule } from '@shared/core/modules/order/components/orderId';
import { LoadersModule } from '@shared/core/components/loaders';
import { HintsModule } from '@shared/core/components/hints';
import { BoxModule } from '@shared/core/components/box';
import { ButtonsModule } from '@shared/core/components/buttons';
import { HeadersModule } from '@shared/core/components/headers';
import { StatsModule } from '@shared/core/components/stats';
import { ThumbsModule } from '@shared/core/components/thumbs';

import { TileForHistoryOrderComponent } from './tile-for-history-order.shared.component';

@NgModule({
    declarations: [
        TileForHistoryOrderComponent
    ],
    imports: [
        CommonModule,
        OrderIdModule,
        TruncatePipeModule,
        HeadersModule,
        HintsModule,
        LoadersModule,
        ButtonsModule,
        BoxModule,
        StatsModule,
        ThumbsModule
    ],
    exports: [
        TileForHistoryOrderComponent
    ],
    providers: [],
})
export class TileForHistoryOrderModule { }
